export const getClientEnv = (key, fallback = '') => {
  if (typeof process !== 'undefined' && process?.env && Object.prototype.hasOwnProperty.call(process.env, key)) {
    return process.env[key] ?? fallback;
  }
  return fallback;
};

export const isMicrosoftOAuthEnabled = () => getClientEnv('REACT_APP_ENABLE_MICROSOFT_OAUTH', 'false') === 'true';
